import React, { useState } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import Avatar from '@material-ui/core/Avatar'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import FileUploadOutlinedIcon from 'components/material-symbol/icons/FileUpload'
import secureLink from 'utils/secureLink'
import { getInitials } from 'lib/text-display'
import { handleImageUpload } from 'lib/cloudinary/uploadImage'
import { CLOUDINARY_CLOUDNAME, CLOUDINARY_UPLOAD_PRESET } from 'env'
import { useStyles as useFormSectionStyles } from 'pages/pga-coach/bookings/events/edit/edit-event-form/styles'
import { useCreateProfileFieldStyles } from '../create-profile-form/field-styles'

const uploadOptions = {
  cloudName: CLOUDINARY_CLOUDNAME,
  upload_preset: CLOUDINARY_UPLOAD_PRESET,
  cropping: true,
  sources: ['local', 'camera'],
  multiple: false,
  croppingAspectRatio: 1,
  resourceType: 'image',
  showSkipCropButton: false,
  folder: 'dot-com-images',
  showPoweredBy: false,
}

const profileImgMsg = 'Recommended dimensions of 400x400'

const ProfilePhotoStep = ({ memberProfile }) => {
  const classes = useCreateProfileFieldStyles()
  const formSectionClasses = useFormSectionStyles()
  const { control, setValue, watch } = useFormContext()
  const [uploadError, setUploadError] = useState(null)

  const firstName = watch('firstName') || memberProfile?.firstName || ''
  const lastName = watch('lastName') || memberProfile?.lastName || ''
  const initials = getInitials(`${firstName} ${lastName}`)

  return (
    <Controller
      name="profilePhoto"
      control={control}
      defaultValue={memberProfile?.photo}
      render={({ value }) => (
        <Box className={classes.profilePhotoRow}>
          <Avatar
            className={classes.profileAvatar}
            alt="Coach portrait"
            src={value ? secureLink(value) : undefined}
          >
            {initials}
          </Avatar>
          <Box className={classes.profilePhotoActions}>
            <Box className={classes.profilePhotoButtonRow}>
              <Button
                variant="outlined"
                color="primary"
                type="button"
                className={formSectionClasses.outlinedButton}
                startIcon={<FileUploadOutlinedIcon />}
                onClick={() =>
                  handleImageUpload(
                    uploadOptions,
                    setValue,
                    setUploadError,
                    'profilePhoto',
                  )
                }
              >
                {value ? 'Change picture' : 'Upload picture'}
              </Button>
              {value ? (
                <Button
                  variant="text"
                  color="primary"
                  type="button"
                  onClick={() => {
                    setValue('profilePhoto', null)
                  }}
                >
                  Remove
                </Button>
              ) : null}
            </Box>
            {uploadError ? (
              <Typography variant="body2" color="error">
                {uploadError}
              </Typography>
            ) : (
              <Typography className={classes.profilePhotoCaption}>
                {profileImgMsg}
              </Typography>
            )}
          </Box>
        </Box>
      )}
    />
  )
}

export default ProfilePhotoStep
